var _style, _circle, _circle2, _path, _path2, _circle3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCar3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    height: 80,
    width: 80,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.25;fill:#D83D35;}\n\t.st1{fill:#D83D35;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#0C0909;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "circle_50x50__x28_opacity_25_x25__x29_",
    className: "st0",
    cx: 40,
    cy: 38.3,
    r: 37.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "circle_70x70",
    className: "st1",
    cx: 40,
    cy: 38.3,
    r: 25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "dash_00000139253284026353745300000014345442520698755993_",
    className: "st2",
    d: "M54.2,73.7l-0.5-1.3 c9.1-3.6,16.2-10.6,20.1-19.6l1.3,0.5l0,0.1C71.1,62.7,63.7,69.9,54.2,73.7z M25,73.4L25,73.4c-9.5-4.1-16.7-11.5-20.5-21l1.3-0.5 C9.5,61,16.4,68.2,25.5,72l0.1,0L25,73.4z M74.2,24.6C70.5,15.5,63.5,8.3,54.5,4.5L55,3.1l0.1,0c9.3,4,16.6,11.4,20.4,20.9 L74.2,24.6z M6.2,23.7l-1.3-0.5l0,0c4-9.4,11.5-16.6,20.9-20.4l0.5,1.3C17.2,7.7,10.1,14.7,6.2,23.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "vector_arrow",
    className: "st3",
    d: "M34.7,32.3c0.1,0,0.3,0,0.4,0.1l4.6,3c0.1,0.1,0.2,0.1,0.4,0.1c0.1,0,0.3,0,0.4-0.1l4.6-3 c0.1-0.1,0.3-0.1,0.4-0.1s0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.2,0.2,0.4c0,0.1,0,0.3-0.1,0.4l-5.3,10.7c-0.1,0.1-0.1,0.2-0.2,0.3 c-0.1,0.1-0.2,0.1-0.3,0.1s-0.2,0-0.3-0.1c-0.1-0.1-0.2-0.2-0.2-0.3l-5.3-10.7C34,33.1,34,32.9,34,32.8c0-0.1,0.1-0.3,0.2-0.4 C34.4,32.3,34.5,32.3,34.7,32.3z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "circle_7x7",
    className: "st1",
    cx: 40,
    cy: 75.8,
    r: 3.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar3);
export default __webpack_public_path__ + "static/media/car_3.5ffbfa2d3c90ed5e4cdd6c07b0a3961f.svg";
export { ForwardRef as ReactComponent };